module.exports = __webpack_public_path__ + "static/media/freedom_business_blueprint.796c0b21.jpg";